//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.19.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions  } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './NotificationClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetNotificationsNotificationQueryParameters = {
  isRead?: boolean | null | null;
  studyId?: number | null | null;
  types?: Types.NotificationType[] | null | null;
  offset?: number | null | null;
  limit?: number | null | null;
  sortBy?: string | null | null;
  sortOrder?: Types.SortOrder | null;
};

export type GetNotificationBatchesNotificationQueryParameters = {
  types?: Types.NotificationType[] | null | null;
  studyIds?: number[] | null | null;
  isSent?: boolean | null | null;
  isRead?: boolean | null | null;
  deliveryTypes?: Types.NotificationDeliveryType[] | null | null;
};

export type GetNotificationCountsNotificationQueryParameters = {
  studyId?: number | null;
};

    
export function getNotificationsUrl(isRead?: boolean | null | undefined, studyId?: number | null | undefined, types?: Types.NotificationType[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): string {
  let url_ = getBaseUrl() + "/api/notifications?";
if (isRead !== undefined && isRead !== null)
    url_ += "IsRead=" + encodeURIComponent("" + isRead) + "&";
if (studyId !== undefined && studyId !== null)
    url_ += "StudyId=" + encodeURIComponent("" + studyId) + "&";
if (types !== undefined && types !== null)
    types && types.forEach(item => { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
if (offset !== undefined && offset !== null)
    url_ += "Offset=" + encodeURIComponent("" + offset) + "&";
if (limit !== undefined && limit !== null)
    url_ += "Limit=" + encodeURIComponent("" + limit) + "&";
if (sortBy !== undefined && sortBy !== null)
    url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
if (sortOrder === null)
    throw new Error("The parameter 'sortOrder' cannot be null.");
else if (sortOrder !== undefined)
    url_ += "SortOrder=" + encodeURIComponent("" + sortOrder) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getNotificationsDefaultOptions: UseQueryOptions<Types.PagedResultOfNotificationDto, unknown, Types.PagedResultOfNotificationDto> = {
  queryFn: __getNotifications,
};
export function getGetNotificationsDefaultOptions(): UseQueryOptions<Types.PagedResultOfNotificationDto, unknown, Types.PagedResultOfNotificationDto> {
  return getNotificationsDefaultOptions;
};
export function setGetNotificationsDefaultOptions(options: UseQueryOptions<Types.PagedResultOfNotificationDto, unknown, Types.PagedResultOfNotificationDto>) {
  getNotificationsDefaultOptions = options;
}

export function getNotificationsQueryKey(dto: GetNotificationsNotificationQueryParameters): QueryKey;
export function getNotificationsQueryKey(isRead?: boolean | null | undefined, studyId?: number | null | undefined, types?: Types.NotificationType[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined): QueryKey;
export function getNotificationsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { isRead, studyId, types, offset, limit, sortBy, sortOrder,  } = params[0] as GetNotificationsNotificationQueryParameters;

    return trimArrayEnd([
        'NotificationClient',
        'getNotifications',
        isRead as any,
        studyId as any,
        types as any,
        offset as any,
        limit as any,
        sortBy as any,
        sortOrder as any,
      ]);
  } else {
    return trimArrayEnd([
        'NotificationClient',
        'getNotifications',
        ...params
      ]);
  }
}
function __getNotifications(context: QueryFunctionContext) {
  return Client.getNotifications(
      context.queryKey[2] as boolean | null | undefined,       context.queryKey[3] as number | null | undefined,       context.queryKey[4] as Types.NotificationType[] | null | undefined,       context.queryKey[5] as number | null | undefined,       context.queryKey[6] as number | null | undefined,       context.queryKey[7] as string | null | undefined,       context.queryKey[8] as Types.SortOrder | undefined    );
}

export function useGetNotificationsQuery<TSelectData = Types.PagedResultOfNotificationDto, TError = unknown>(dto: GetNotificationsNotificationQueryParameters, options?: UseQueryOptions<Types.PagedResultOfNotificationDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets all notifications for user.
 * @param isRead (optional) Filter for getting read or unread notifications.
 * @param studyId (optional) Filter by StudyId.
If value is not defined all notifications from whole studies will be returned.
 * @param types (optional) Filter by types
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function useGetNotificationsQuery<TSelectData = Types.PagedResultOfNotificationDto, TError = unknown>(isRead?: boolean | null | undefined, studyId?: number | null | undefined, types?: Types.NotificationType[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined, options?: UseQueryOptions<Types.PagedResultOfNotificationDto, TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetNotificationsQuery<TSelectData = Types.PagedResultOfNotificationDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PagedResultOfNotificationDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let isRead: any = undefined;
  let studyId: any = undefined;
  let types: any = undefined;
  let offset: any = undefined;
  let limit: any = undefined;
  let sortBy: any = undefined;
  let sortOrder: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ isRead, studyId, types, offset, limit, sortBy, sortOrder,  } = params[0] as GetNotificationsNotificationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [isRead, studyId, types, offset, limit, sortBy, sortOrder, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.PagedResultOfNotificationDto, TError, TSelectData>({
    queryFn: __getNotifications,
    queryKey: getNotificationsQueryKey(isRead, studyId, types, offset, limit, sortBy, sortOrder),
    ...getNotificationsDefaultOptions as unknown as UseQueryOptions<Types.PagedResultOfNotificationDto, TError, TSelectData>,
    ...options,
  });
}
/**
 * Gets all notifications for user.
 * @param isRead (optional) Filter for getting read or unread notifications.
 * @param studyId (optional) Filter by StudyId.
If value is not defined all notifications from whole studies will be returned.
 * @param types (optional) Filter by types
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetNotificationsData(queryClient: QueryClient, updater: (data: Types.PagedResultOfNotificationDto | undefined) => Types.PagedResultOfNotificationDto, isRead?: boolean | null | undefined, studyId?: number | null | undefined, types?: Types.NotificationType[] | null | undefined, offset?: number | null | undefined, limit?: number | null | undefined, sortBy?: string | null | undefined, sortOrder?: Types.SortOrder | undefined) {
  queryClient.setQueryData(getNotificationsQueryKey(isRead, studyId, types, offset, limit, sortBy, sortOrder),
    updater
  );
}

/**
 * Gets all notifications for user.
 * @param isRead (optional) Filter for getting read or unread notifications.
 * @param studyId (optional) Filter by StudyId.
If value is not defined all notifications from whole studies will be returned.
 * @param types (optional) Filter by types
 * @param offset (optional) Offset of list.
 * @param limit (optional) Number of requested records.
 * @param sortBy (optional) Field name for sorting in DB.
 * @param sortOrder (optional) Sort direction. Ascending or Descending.
 */
export function setGetNotificationsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PagedResultOfNotificationDto | undefined) => Types.PagedResultOfNotificationDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function readAllNotificationsUrl(studyId?: number | null | undefined): string {
  let url_ = getBaseUrl() + "/api/notifications?";
if (studyId !== undefined && studyId !== null)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function readAllNotificationsMutationKey(studyId?: number | null | undefined): MutationKey {
  return trimArrayEnd([
      'NotificationClient',
      'readAllNotifications',
      studyId as any,
    ]);
}

/**
 * Mark all notifications as read.
 * @param studyId (optional) 
 */
export function useReadAllNotificationsMutation<TContext>(studyId?: number | null | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = readAllNotificationsMutationKey(studyId);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.readAllNotifications(studyId), {...options, mutationKey: key});
}
  
    
export function getNotificationBatchesUrl(types?: Types.NotificationType[] | null | undefined, studyIds?: number[] | null | undefined, isSent?: boolean | null | undefined, isRead?: boolean | null | undefined, deliveryTypes?: Types.NotificationDeliveryType[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/notifications/batches?";
if (types !== undefined && types !== null)
    types && types.forEach(item => { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
if (studyIds !== undefined && studyIds !== null)
    studyIds && studyIds.forEach(item => { url_ += "StudyIds=" + encodeURIComponent("" + item) + "&"; });
if (isSent !== undefined && isSent !== null)
    url_ += "IsSent=" + encodeURIComponent("" + isSent) + "&";
if (isRead !== undefined && isRead !== null)
    url_ += "IsRead=" + encodeURIComponent("" + isRead) + "&";
if (deliveryTypes !== undefined && deliveryTypes !== null)
    deliveryTypes && deliveryTypes.forEach(item => { url_ += "DeliveryTypes=" + encodeURIComponent("" + item) + "&"; });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getNotificationBatchesDefaultOptions: UseQueryOptions<Types.NotificationBatchDto[], unknown, Types.NotificationBatchDto[]> = {
  queryFn: __getNotificationBatches,
};
export function getGetNotificationBatchesDefaultOptions(): UseQueryOptions<Types.NotificationBatchDto[], unknown, Types.NotificationBatchDto[]> {
  return getNotificationBatchesDefaultOptions;
};
export function setGetNotificationBatchesDefaultOptions(options: UseQueryOptions<Types.NotificationBatchDto[], unknown, Types.NotificationBatchDto[]>) {
  getNotificationBatchesDefaultOptions = options;
}

export function getNotificationBatchesQueryKey(dto: GetNotificationBatchesNotificationQueryParameters): QueryKey;
export function getNotificationBatchesQueryKey(types?: Types.NotificationType[] | null | undefined, studyIds?: number[] | null | undefined, isSent?: boolean | null | undefined, isRead?: boolean | null | undefined, deliveryTypes?: Types.NotificationDeliveryType[] | null | undefined): QueryKey;
export function getNotificationBatchesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { types, studyIds, isSent, isRead, deliveryTypes,  } = params[0] as GetNotificationBatchesNotificationQueryParameters;

    return trimArrayEnd([
        'NotificationClient',
        'getNotificationBatches',
        types as any,
        studyIds as any,
        isSent as any,
        isRead as any,
        deliveryTypes as any,
      ]);
  } else {
    return trimArrayEnd([
        'NotificationClient',
        'getNotificationBatches',
        ...params
      ]);
  }
}
function __getNotificationBatches(context: QueryFunctionContext) {
  return Client.getNotificationBatches(
      context.queryKey[2] as Types.NotificationType[] | null | undefined,       context.queryKey[3] as number[] | null | undefined,       context.queryKey[4] as boolean | null | undefined,       context.queryKey[5] as boolean | null | undefined,       context.queryKey[6] as Types.NotificationDeliveryType[] | null | undefined    );
}

export function useGetNotificationBatchesQuery<TSelectData = Types.NotificationBatchDto[], TError = unknown>(dto: GetNotificationBatchesNotificationQueryParameters, options?: UseQueryOptions<Types.NotificationBatchDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get notification batches that can be used to display to a user
one notification instead of many ones of the same type
 * @param types (optional) 
 * @param studyIds (optional) 
 * @param isSent (optional) 
 * @param isRead (optional) 
 * @param deliveryTypes (optional) 
 */
export function useGetNotificationBatchesQuery<TSelectData = Types.NotificationBatchDto[], TError = unknown>(types?: Types.NotificationType[] | null | undefined, studyIds?: number[] | null | undefined, isSent?: boolean | null | undefined, isRead?: boolean | null | undefined, deliveryTypes?: Types.NotificationDeliveryType[] | null | undefined, options?: UseQueryOptions<Types.NotificationBatchDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetNotificationBatchesQuery<TSelectData = Types.NotificationBatchDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.NotificationBatchDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let types: any = undefined;
  let studyIds: any = undefined;
  let isSent: any = undefined;
  let isRead: any = undefined;
  let deliveryTypes: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ types, studyIds, isSent, isRead, deliveryTypes,  } = params[0] as GetNotificationBatchesNotificationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [types, studyIds, isSent, isRead, deliveryTypes, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.NotificationBatchDto[], TError, TSelectData>({
    queryFn: __getNotificationBatches,
    queryKey: getNotificationBatchesQueryKey(types, studyIds, isSent, isRead, deliveryTypes),
    ...getNotificationBatchesDefaultOptions as unknown as UseQueryOptions<Types.NotificationBatchDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Get notification batches that can be used to display to a user
one notification instead of many ones of the same type
 * @param types (optional) 
 * @param studyIds (optional) 
 * @param isSent (optional) 
 * @param isRead (optional) 
 * @param deliveryTypes (optional) 
 */
export function setGetNotificationBatchesData(queryClient: QueryClient, updater: (data: Types.NotificationBatchDto[] | undefined) => Types.NotificationBatchDto[], types?: Types.NotificationType[] | null | undefined, studyIds?: number[] | null | undefined, isSent?: boolean | null | undefined, isRead?: boolean | null | undefined, deliveryTypes?: Types.NotificationDeliveryType[] | null | undefined) {
  queryClient.setQueryData(getNotificationBatchesQueryKey(types, studyIds, isSent, isRead, deliveryTypes),
    updater
  );
}

/**
 * Get notification batches that can be used to display to a user
one notification instead of many ones of the same type
 * @param types (optional) 
 * @param studyIds (optional) 
 * @param isSent (optional) 
 * @param isRead (optional) 
 * @param deliveryTypes (optional) 
 */
export function setGetNotificationBatchesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.NotificationBatchDto[] | undefined) => Types.NotificationBatchDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function getNotificationCountsUrl(studyId?: number | undefined): string {
  let url_ = getBaseUrl() + "/api/notifications/counts?";
if (studyId === null)
    throw new Error("The parameter 'studyId' cannot be null.");
else if (studyId !== undefined)
    url_ += "studyId=" + encodeURIComponent("" + studyId) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getNotificationCountsDefaultOptions: UseQueryOptions<Types.NotificationCountsByTypeDto[], unknown, Types.NotificationCountsByTypeDto[]> = {
  queryFn: __getNotificationCounts,
};
export function getGetNotificationCountsDefaultOptions(): UseQueryOptions<Types.NotificationCountsByTypeDto[], unknown, Types.NotificationCountsByTypeDto[]> {
  return getNotificationCountsDefaultOptions;
};
export function setGetNotificationCountsDefaultOptions(options: UseQueryOptions<Types.NotificationCountsByTypeDto[], unknown, Types.NotificationCountsByTypeDto[]>) {
  getNotificationCountsDefaultOptions = options;
}

export function getNotificationCountsQueryKey(studyId?: number | undefined): QueryKey;
export function getNotificationCountsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { studyId,  } = params[0] as GetNotificationCountsNotificationQueryParameters;

    return trimArrayEnd([
        'NotificationClient',
        'getNotificationCounts',
        studyId as any,
      ]);
  } else {
    return trimArrayEnd([
        'NotificationClient',
        'getNotificationCounts',
        ...params
      ]);
  }
}
function __getNotificationCounts(context: QueryFunctionContext) {
  return Client.getNotificationCounts(
      context.queryKey[2] as number | undefined    );
}

export function useGetNotificationCountsQuery<TSelectData = Types.NotificationCountsByTypeDto[], TError = unknown>(dto: GetNotificationCountsNotificationQueryParameters, options?: UseQueryOptions<Types.NotificationCountsByTypeDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Get counts of notifications for current user
 * @param studyId (optional) Id of the study that the notifications must relate to
 * @return Counts of notifications grouped by type
 */
export function useGetNotificationCountsQuery<TSelectData = Types.NotificationCountsByTypeDto[], TError = unknown>(studyId?: number | undefined, options?: UseQueryOptions<Types.NotificationCountsByTypeDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetNotificationCountsQuery<TSelectData = Types.NotificationCountsByTypeDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.NotificationCountsByTypeDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  let studyId: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ studyId,  } = params[0] as GetNotificationCountsNotificationQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [studyId, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.NotificationCountsByTypeDto[], TError, TSelectData>({
    queryFn: __getNotificationCounts,
    queryKey: getNotificationCountsQueryKey(studyId),
    ...getNotificationCountsDefaultOptions as unknown as UseQueryOptions<Types.NotificationCountsByTypeDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Get counts of notifications for current user
 * @param studyId (optional) Id of the study that the notifications must relate to
 * @return Counts of notifications grouped by type
 */
export function setGetNotificationCountsData(queryClient: QueryClient, updater: (data: Types.NotificationCountsByTypeDto[] | undefined) => Types.NotificationCountsByTypeDto[], studyId?: number | undefined) {
  queryClient.setQueryData(getNotificationCountsQueryKey(studyId),
    updater
  );
}

/**
 * Get counts of notifications for current user
 * @param studyId (optional) Id of the study that the notifications must relate to
 * @return Counts of notifications grouped by type
 */
export function setGetNotificationCountsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.NotificationCountsByTypeDto[] | undefined) => Types.NotificationCountsByTypeDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function readNotificationUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/notifications/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function readNotificationMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'NotificationClient',
      'readNotification',
      id as any,
    ]);
}

/**
 * Mark specific notification as read.
 */
export function useReadNotificationMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = readNotificationMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.readNotification(id), {...options, mutationKey: key});
}
  
    
export function getPushTokensUrl(): string {
  let url_ = getBaseUrl() + "/api/notifications/tokens";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getPushTokensDefaultOptions: UseQueryOptions<Types.UserPushTokenDto[], unknown, Types.UserPushTokenDto[]> = {
  queryFn: __getPushTokens,
};
export function getGetPushTokensDefaultOptions(): UseQueryOptions<Types.UserPushTokenDto[], unknown, Types.UserPushTokenDto[]> {
  return getPushTokensDefaultOptions;
};
export function setGetPushTokensDefaultOptions(options: UseQueryOptions<Types.UserPushTokenDto[], unknown, Types.UserPushTokenDto[]>) {
  getPushTokensDefaultOptions = options;
}

export function getPushTokensQueryKey(): QueryKey;
export function getPushTokensQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'NotificationClient',
      'getPushTokens',
    ]);
}
function __getPushTokens() {
  return Client.getPushTokens(
    );
}

/**
 * Get list of mobile (FCM) tokens for current user.
 */
export function useGetPushTokensQuery<TSelectData = Types.UserPushTokenDto[], TError = unknown>(options?: UseQueryOptions<Types.UserPushTokenDto[], TError, TSelectData>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetPushTokensQuery<TSelectData = Types.UserPushTokenDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.UserPushTokenDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  if (axiosConfig) {
    options = options ?? { } as any;
    options!.meta = { ...options!.meta, axiosConfig };
  }

  return useQuery<Types.UserPushTokenDto[], TError, TSelectData>({
    queryFn: __getPushTokens,
    queryKey: getPushTokensQueryKey(),
    ...getPushTokensDefaultOptions as unknown as UseQueryOptions<Types.UserPushTokenDto[], TError, TSelectData>,
    ...options,
  });
}
/**
 * Get list of mobile (FCM) tokens for current user.
 */
export function setGetPushTokensData(queryClient: QueryClient, updater: (data: Types.UserPushTokenDto[] | undefined) => Types.UserPushTokenDto[], ) {
  queryClient.setQueryData(getPushTokensQueryKey(),
    updater
  );
}

/**
 * Get list of mobile (FCM) tokens for current user.
 */
export function setGetPushTokensDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.UserPushTokenDto[] | undefined) => Types.UserPushTokenDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
    
export function savePushTokenUrl(): string {
  let url_ = getBaseUrl() + "/api/notifications/token";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function savePushTokenMutationKey(): MutationKey {
  return trimArrayEnd([
      'NotificationClient',
      'savePushToken',
    ]);
}

/**
 * Saves push notification token and corresponding information for current user.
 * @param dto DTO.
 */
export function useSavePushTokenMutation<TContext>(options?: Omit<UseMutationOptions<void, unknown, Types.SendPushTokenDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.SendPushTokenDto, TContext> {
  const key = savePushTokenMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation((dto: Types.SendPushTokenDto) => Client.savePushToken(dto), {...options, mutationKey: key});
}
  
    
export function deletePushTokenUrl(token?: string | undefined): string {
  let url_ = getBaseUrl() + "/api/notifications/token?";
if (token === null)
    throw new Error("The parameter 'token' cannot be null.");
else if (token !== undefined)
    url_ += "token=" + encodeURIComponent("" + token) + "&";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function deletePushTokenMutationKey(token?: string | undefined): MutationKey {
  return trimArrayEnd([
      'NotificationClient',
      'deletePushToken',
      token as any,
    ]);
}

/**
 * Removes (unsubscribe) push token from server.
After that user will not get any pushes for the device where push token is assigned.
 * @param token (optional) FCM token.
 */
export function useDeletePushTokenMutation<TContext>(token?: string | undefined, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = deletePushTokenMutationKey(token);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
      return useMutation(() => Client.deletePushToken(token), {...options, mutationKey: key});
}